module.exports = __webpack_public_path__ + "static/media/backgroundImage.81ebe100.psd";